import { useAccountStore } from '@/store/modules/account/store.js';
import { useUserStore } from '@/store/modules/user/store.js';
import Division from '@/entities/Division.js';

export const getters = {
    contextTeam() {
        return useAccountStore().contextAccount?.teams.find((team) => team.id == this.teamId) || {};
    },

    contextDivision() {
        return Division.getSelectOption(this.divisionId) || {};
    },

    communicatingLead() {
        const lead = this.lead;
        const user = useUserStore().authUser;

        if (!lead.id) {
            return null;
        }

        return this.communicatingLeads.find((communicatingLead) => {
            return (
                communicatingLead.id === lead.id &&
                !user?.isSameUser(communicatingLead.communicating_user.id)
            );
        });
    },
};
